import { CSSProperties } from 'react';

import { cn } from '@/lib/utils';

export type OverlayProps = {
  fullScreen?: boolean;
  darkOverlay?: boolean;
  classNames?: { root?: string };
  style?: CSSProperties;
};

export function Overlay({
  fullScreen,
  darkOverlay,
  classNames,
  style,
}: OverlayProps) {
  return (
    <div
      data-header-blur-background
      className={cn(
        'fixed left-0 top-12 z-20 h-full w-full backdrop-blur-sm md:top-16',
        fullScreen && 'top-0 md:top-0',
        darkOverlay && 'bg-gray-950/50 dark:bg-gray-dark-950/50',
        classNames?.root
      )}
      style={style}
    />
  );
}
